import React from "react";
import Modal from "sushiweb/Modal";
import TableFields from "../../../constants/LifeLine/TableFields.json";
import {
  getPath,
  getReadableDateTime,
  isEmpty,
  isValNull,
} from "../../../utils";
import Table from "../../Common/Table";

const CallLogsModal = (props) => {
  const { showModal, handleClose, modalContent } = props;
  const callLogs = getPath(modalContent, "call_logs", []);

  const getFieldValue = (obj, key) => {
    switch (key) {
      case "call_time":
        return getReadableDateTime(obj[key]);
      case "call_duration":
        let callDuration = isValNull(obj[key]) ? "N/A" : obj[key] + " secs";
        return callDuration;
      case "rec_url":
        if (obj[key]) {
          return (
            <a href={obj[key]} target="_blank" rel="noopener noreferrer">
              Listen
            </a>
          );
        } else {
          return <></>;
        }
      default:
        return obj[key];
    }
  };

  return (
    <>
      {showModal && (
        <Modal
          visible={showModal}
          onClose={handleClose}
          type="medium"
          showCloseIcon={true}
          slideOnMobile
          isCentered
          padding="2rem"
          preventFocus
        >
          {isEmpty(callLogs) ? (
            <p
              style={{
                textAlign: "center",
              }}
            >
              No call logs found
            </p>
          ) : (
            <Table
              list={callLogs}
              getFieldValue={getFieldValue}
              fields={TableFields}
            />
          )}
        </Modal>
      )}
    </>
  );
};

export default CallLogsModal;
